import Icon from "assets/icons";
import ClientLogo from "../clientLogo";
import { useLocation } from "react-router-dom";
import { useCopies } from "shared/hooks/useCopies";
import { PERSONATECH_URL } from "shared/utils/constants";
import { ConsoleRouteMap } from "apps/console/routes/routes";
import { HeaderLogoConfig } from "./types";
import React from "react";

export default function HeaderLogo(props: HeaderLogoConfig) {
  const copies = useCopies();
  const location = useLocation();
  const showClientLogo = React.useMemo(() => {
    return !(
      location.pathname.startsWith(`/${ConsoleRouteMap.HOME.clientList.path}`) ||
      location.pathname.startsWith(ConsoleRouteMap.CLIENT.path) ||
      !props.clientLogoUrl
    );
  }, [props.clientLogoUrl, location.pathname]);

  return (
    <div className="consoleHeader_logoWrapper">
      <div className="consoleHeader_mainLogo">
        <a target="_blank" rel="noreferrer" href={PERSONATECH_URL} title={copies.get("personatech")}>
          <Icon.PersonatechColored />
        </a>
      </div>
      {showClientLogo && (
        <div className="consoleHeader_clientLogo">
          <ClientLogo clientName={props.clientName} clientLogoUrl={props.clientLogoUrl} />
        </div>
      )}
    </div>
  );
}
